import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/lv'
import 'dayjs/locale/ru'
import duration from 'dayjs/plugin/duration'

import { i18n } from './i18n'

dayjs.extend(duration)
dayjs.locale(i18n.locale)
